import React from 'react';
import './App.css';
import Header from './components/Header';
import Profile from './components/Profile';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';
import AIProjects from './components/AIProjects';
import AIModal from './components/AIModal'; // 🆕

function App() {
  return (
    <div className="App">
      <Header />
      <AIModal /> {/* 👈 Auto-popup ad */}
      <main>
        <Profile />
        <Experience />
        <Skills />
        <AIProjects />
        <Projects />
        <Education />
        <Contact />
      </main>
    </div>
  );
}

export default App;
